var map = {
	"./custom.png": "itC0",
	"./email.png": "LORI",
	"./instagram.png": "lXjd",
	"./linkedin.png": "/Yid",
	"./messenger.png": "y/gN",
	"./whatsapp.png": "521b",
	"./x.png": "VaQs",
	"./youtube.png": "11le"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Hfj/";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button ^\.\/.*\.png$
// module id = Hfj/
// module chunks = 46